export class MediaBreakpoints {
    static readonly Mobile = 375;

    static readonly Tablet = 768;

    static readonly Desktop = 1024;

    static readonly DesktopHD = 1440;
}
